export default __webpack_public_path__ + "static/media/poppy_showcase_1.webp";